var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time-tracking-dashboard"},[_c('CardProfile',{attrs:{"full-name":"Jeremy Robson","avatar-image":_vm.avatarImage}}),_vm._l((_vm.getCategories),function(c){return _c('CardTime',{key:c,attrs:{"card-type":c}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }